import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** A page that may hold unsaved changes and asks before it is left. */
export interface CanLeavePage {
  canDeactivate(): boolean | Observable<boolean>;
}

/**
 * Leaving the event form with unsaved changes asks first, in the design's own
 * dialog ("Leave without saving?"). The question lives on the component; this
 * guard only routes every way out — the Back link, Cancel, the sidebar, the
 * browser's back button — through it. Typed on the interface so the route
 * table does not pull the form into the main bundle.
 */
export const eventFormLeaveGuard: CanDeactivateFn<CanLeavePage> =
  (component: CanLeavePage | null) => (component && typeof component.canDeactivate === 'function' ? component.canDeactivate() : true);
